import React from 'react';
import { NavbarPageActions } from '../layout/NavbarPageActions';

interface OrdersListNavbarActionsProps {
  readonly hideIssues: boolean;
  readonly onToggleHideIssues: () => void;
  readonly onOpenSearch: () => void;
}

function OrdersListNavbarActions({
  hideIssues,
  onToggleHideIssues,
  onOpenSearch,
}: OrdersListNavbarActionsProps): React.ReactElement {
  return (
    <NavbarPageActions>
      <button
        type="button"
        className="orders-hide-issues-btn"
        aria-pressed={hideIssues}
        onClick={onToggleHideIssues}
      >
        {hideIssues ? 'Show issues' : 'Hide issues'}
      </button>
      <button
        type="button"
        className="orders-search-icon"
        aria-label="Search orders"
        onClick={onOpenSearch}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="10.5" cy="10.5" r="6.5" />
          <line x1="15.5" y1="15.5" x2="21" y2="21" />
        </svg>
      </button>
    </NavbarPageActions>
  );
}

export default OrdersListNavbarActions;
